// removed by extract-text-webpack-plugin
module.exports = {"actionItem":"VcUai","actionWrapper":"_39hWI","actionText":"_33TU9","icon":"O7y0d","separator":"_3hGsT"};


//////////////////
// WEBPACK FOOTER
// ./app/components/action-button/action-button.scss
// module id = 931
// module chunks = 3 4 5 6 7